module.exports = __webpack_public_path__ + "img/banner_test_02.1f0684b4.webp";